if (!customElements.get('ct-product-reviews')) {
  customElements.define('ct-product-reviews', class extends HTMLElement {
    connectedCallback() {
      const product = document.querySelector('[id^="ProductSection-"][style*="--ctPdpMax"]');
      if (product) this.style.setProperty('--ct-review-width', product.style.getPropertyValue('--ctPdpMax'));
      this.decorateReplies();
      this.observer = new MutationObserver(() => this.decorateReplies());
      this.observer.observe(this, { childList: true, subtree: true });
    }
    disconnectedCallback() { this.observer?.disconnect(); }
    decorateReplies() {
      this.querySelectorAll('.jdgm-rev__reply').forEach(reply => {
        const content = reply.querySelector('.jdgm-rev__reply-content');
        if (!content || !content.textContent.trim()) {
          reply.querySelector('.ct-review-reply-profile')?.remove();
          reply.hidden = true;
          return;
        }
        reply.hidden = false;
        if (reply.querySelector('.ct-review-reply-profile')) return;
        const header = document.createElement('div');
        header.className = 'ct-review-reply-profile';
        if (this.dataset.replyLogo) {
          const image = document.createElement('img');
          image.className = 'ct-review-reply-logo';
          image.src = this.dataset.replyLogo;
          image.alt = '';
          image.width = 38;
          image.height = 38;
          image.loading = 'lazy';
          header.append(image);
        }
        const name = reply.querySelector('.jdgm-rev__replier') || document.createElement('span');
        if (!name.classList.contains('jdgm-rev__replier')) {
          name.className = 'ct-review-reply-name';
          name.textContent = this.dataset.replyName || 'Cosmetique Totale';
        }
        header.append(name);
        reply.prepend(header);
      });
    }
  });
}
